import template from './template';
import entry from './plugins/entry';
import globalStyle from './plugins/globalStyle';
import packageJSON from './plugins/packageJSON';
import config from './plugins/config';
import router from './plugins/router';
import detailsMap from './plugins/detailsMap';

export default {
  template,
  plugins: {
    entry,
    globalStyle,
    packageJSON,
    config,
    router,
    detailsMap,
  },
};
